import { payoutRequestQueryKeys as e } from "./usePayoutRequestQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { paymentsApi as n } from "@maat/api-payments";
//#region src/payout-requests/usePayoutRequestsQuery.ts
var r = (r, i) => t({
	queryKey: e.forWorkspace(r),
	queryFn: () => n.listPayoutRequests(i),
	enabled: !!r
});
//#endregion
export { r as usePayoutRequestsQuery };
